module.exports = __webpack_public_path__ + "img/3.c72f8a20.png";